export const CHANGE_CURRENT_NARRATOR_BLOCK =
  'app/containers/EditSessionPage/CHANGE_CURRENT_NARRATOR_BLOCK';

export const TOGGLE_QUESTION_SETTINGS =
  'app/EditSessionPage/TOGGLE_QUESTION_SETTINGS';

export const SET_QUESTION_SETTINGS =
  'app/EditSessionPage/SET_QUESTION_SETTINGS';

export const UPDATE_PREVIEW_ANIMATION =
  'app/EditSessionPage/UPDATE_PREVIEW_ANIMATION';
export const UPDATE_PREVIEW_DATA = 'app/EditSessionPage/UPDATE_PREVIEW_DATA';

export const MAKE_CHARACTER_DRAGGABLE =
  'app/EditSessionPage/MAKE_CHARACTER_DRAGGABLE';
export const SET_ANIMATION_STOP_POSITION =
  'app/EditSessionPage/SET_ANIMATION_STOP_POSITION';
